import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from "./auth/authConfig";
import { UserProvider } from "./contexts/UserContext";
import CONFIG from './config';

window.CONFIG = CONFIG;
const msalInstance = new PublicClientApplication(msalConfig);

const initializeApp = async () => {

  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <UserProvider>
            <App />
          </UserProvider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

initializeApp();
